module.exports = __webpack_public_path__ + "img/wx.7e45d736.jpg";